import { InputBase, InputBaseProps } from '@material-ui/core';
import React, { Ref } from 'react';

import inputStyles from './DrillxInput.module.scss';

const DrillxInput = (
  { ...otherProps }: Omit<InputBaseProps, 'classes' | 'fullWidth'>,
  ref: Ref<HTMLInputElement> | null,
) => <InputBase ref={ref} {...otherProps} classes={inputStyles} fullWidth={true} />;

export default React.forwardRef(DrillxInput);
